import styled, { css } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const IconWrapper = styled.div`
	display: flex;
	align-items: center;
	width: 20px;
`;

export const Label = styled.div`
	font-size: 16px;
	line-height: 20px;
	color: ${colors.grey8};
	padding-left: 6px;
	cursor: default;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;

	span {
		font-weight: 500;
	}
`;

export const Wrapper = styled.div`
	display: flex;
	padding: 8px;
	align-items: center;

	${({ suppressHover, disabled }) =>
		!suppressHover &&
		!disabled &&
		css`
			&:hover {
				background-color: ${colors.green0};
			}
		`};

	${({ isSelected }) =>
		isSelected &&
		css`
			${Label} {
				color: ${colors.grey7};
			}
		`};

	${({ disabled }) =>
		disabled &&
		css`
			${Label} {
				color: ${colors.grey4};
			}
		`};

	${({ small }) =>
		small &&
		css`
			padding-top: 6px;
			padding-bottom: 6px;

			${Label} {
				color: ${colors.grey5};
				font-size: 13px;
				line-height: 16px;
			}
		`};
`;
